
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M3.63552 3l2.31775 2.31776c.06231.0623.06231.13084 0 .2056l-.42991.42991c-.07476.06231-.1433.06231-.2056 0l-.39253-.41121L3 3.63552.682244 5.95327c-.062305.06231-.130841.06231-.205607 0l-.429908-.42991c-.0623053-.07476-.0623053-.1433 0-.2056L2.36448 3 .046729.682244c-.0623053-.062305-.0623053-.130841 0-.205607L.476637.046729c.074766-.0623053.143302-.0623053.205607 0L3 2.36448 5.31775.046729c.06231-.0623053.13084-.0623053.20561 0l.42991.429908c.0623.074766.0623.143302 0 .205607l-.41122.392526L3.63552 3z"}})])
          )
        }
      }
    